import { render, staticRenderFns } from "./AssetIconPicker.vue?vue&type=template&id=6bfcac28&scoped=true"
import script from "./AssetIconPicker.vue?vue&type=script&lang=ts"
export * from "./AssetIconPicker.vue?vue&type=script&lang=ts"
import style0 from "./AssetIconPicker.vue?vue&type=style&index=0&id=6bfcac28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bfcac28",
  null
  
)

export default component.exports